<template>
<div v-if="!hasVariants" class="empty-cart quick-form">
  <div class="quick-form__icon">
    <IconCartPut/>
  </div>
  <h1 class="quick-form__title">Ваша корзина пуста</h1>
  <p class="quick-form__subtitle">
    найдите нужный товар через поиск<br>
    или перейдите в каталог товаров
  </p>
  <router-link :to="{ name: 'catalog' }"
               class="btn btn-primary btn-sm btn-rounded empty-cart__catalog-btn quick-form__max-width-block"
  >
    В каталог товаров
  </router-link>
  <truncate-order :condensed="true" class="mt-4" />
</div>
<div v-else class="cart-modal-preview-stage__products-list-and-summary">
  <div class="cart-modal-products-list">
    <cart-product-variant v-for="variant in variants"
                          :key="`cart-product-variant-${variant.uuid}`"
                          :variant="variant"
    />
    <cart-product-reward-card v-if="rewardSelector.available"
                              :promotion-id="rewardSelector.promotion_id"
                              :reward-id="rewardSelector.reward_id"
                              :context="rewardSelector.context"
                              :max-quantity="rewardSelector.max_quantity"
    />
  </div>

  <truncate-order />

  <PaymentSummary
    v-if="!!order.id"
    :payments-preview="$store.state.order.paymentsPreview"
    :order-total-price="$store.state.order.order.id
      ? $store.state.order.order.total_price
      : null
    "
    :order-original-total-price="$store.state.order.order.id
      ? $store.state.order.order.original_total_price
      : null
    "
    :order-discount-difference="$store.state.order.order.id
      ? $store.state.order.order.discount_difference
      : null
    "
  />
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import CartProductVariant from './../CartProductVariant'
import PaymentSummary from '../PaymentSummary.vue'
import CartProductRewardCard from '@/components/cart/CartProductRewardCard'
import TruncateOrder from '@/components/cart/TruncateOrder'

export default {
  components: {
    CartProductVariant,
    CartProductRewardCard,
    IconCartPut: () => import(/* webpackPreload: true */ '@/assets/images/icons/icon-cart-put.svg?inline'),
    PaymentSummary,
    TruncateOrder,
  },

  computed: {
    ...mapGetters({
      hasVariants: 'order/hasVariants',
      variants: 'order/variants',
      order: 'order/order',
      rewardSelector: 'order/rewardSelector',
    }),
  },
}
</script>

<style lang="less">
@import '~@/assets/less/components/quick-form';
</style>
